$ ->
  $ '#persona'
    .click () ->
      navigator.id.get (assertion) ->
        if assertion
          $('input').val assertion
          $('form').submit()
        else
          location.reload()
